import {
  createIndirectPaginationAPIActionGenerator,
  PaginatedAPIRequest,
} from 'utils/apidata';
import { PullRequest, PullRequestStatus } from 'stores/pullRequests/models';

export type PullRequestsRequest = PaginatedAPIRequest<PullRequest> & {
  organizationUUID: string;
  status: PullRequestStatus;
  author?: string;
  title?: string;
  repositoryUUID?: string;
  hasReviews?: boolean;
  pageNumber?: number;
};

export function getPullRequestsKey(request: PullRequestsRequest): string {
  return `${request.organizationUUID}:${request.status}`;
}

export function getPullRequestsPageID(request: PullRequestsRequest) {
  return `${request.pageNumber ?? 1}`;
}

export const generators = {
  pages: createIndirectPaginationAPIActionGenerator<
    PullRequestsRequest,
    PullRequest
  >({
    prefix: 'ORGANIZATIONS/PULL_REQUESTS/PAGES',
    getKey: getPullRequestsKey,
    getPageID: getPullRequestsPageID,
  }),
};
